import React from 'react';
import PropTypes from 'prop-types';
import Subtitle from '../../components/Subtitle';
import Box from './ChooseBox';
import config from '../../../config';
import analytics from '../../applicationServices/analytics/BookingAnalytics';


const Choose = ({ generateUrlString, allowBookWithAnyBarber }) => {
  const barberRoute = generateUrlString(config.urlPatterns.barber);
  const serviceRoute = generateUrlString(config.urlPatterns.service);
  const timeRoute = generateUrlString(config.urlPatterns.time);

  return (
    <div>
      <Subtitle>I want to...</Subtitle>
      <div className="layout">
        <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up">
          <Box to={barberRoute} onClick={() => { analytics.chooseProfessional(); }}>
            Choose a professional
          </Box>
        </div>
        { allowBookWithAnyBarber &&
        <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up">
          <Box to={serviceRoute} onClick={() => { analytics.chooseService(); }}>
            Choose a service
          </Box>
        </div>
        }
        { false && allowBookWithAnyBarber &&
        <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up">
          <Box to={timeRoute}>
            Choose a time
          </Box>
        </div>
        }
      </div>
    </div>
  );
};
Choose.propTypes = {
  generateUrlString: PropTypes.func.isRequired,
  allowBookWithAnyBarber: PropTypes.bool.isRequired,
};

export default Choose;



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/components/Choose.jsx